module.exports = __webpack_public_path__ + "img/66.04a6a264.jpg";